import { times } from 'lodash';
import { Fund, SecurityModel } from 'api';
import { securityTypes } from 'common/constants';
import { CapTableInfo } from 'common/types/capTable';
import { OptionType } from 'components/CustomSelect/types';
import { ICell } from 'models/interfaces/spreadsheet-types/core-types';
import { toString } from 'utilities';

// CAP-TABLE
// 15.  Seniority - LiquidationPriority

export const getPreferredSecurities = ({ columns }: { columns: SecurityModel[] }) =>
  columns.filter(col =>
    [securityTypes.PREFERRED_STOCK, securityTypes.CONVERTIBLE_NOTES].includes(Number(col.security_type))
  ) || [];
export const seniorityOptions = ({ cell: cellInfo }: { cell: ICell }) => {
  const {
    sheet: { columns },
  } = cellInfo as { sheet: { columns: SecurityModel[] } };
  const tmpOptions: OptionType[] = [];

  const preferredSecurities = getPreferredSecurities({ columns });

  if (preferredSecurities.length > 0) {
    times(preferredSecurities.length, i => {
      const priority = i + 1;
      tmpOptions.push({
        value: priority,
        label: priority,
      });
    });
  }
  return tmpOptions;
};

/* FUND-OWNERSHIP
 * 02.  Fund */
export const fundOptions = (fundList: Fund[]) => {
  const tmpOptions: OptionType[] = [];

  if (Array.isArray(fundList)) {
    fundList.forEach(fund => {
      tmpOptions.push({
        value: fund.id?.toString() ?? null,
        label: fund.name,
      });
    });
  }

  return tmpOptions;
};

// 03.  Security type
export const securityOptions = (captableInfo: CapTableInfo) => {
  const tmpOptions: OptionType[] = [];
  const securities = captableInfo?.securities || [];
  const unissuedOptions = securityTypes.UNISSUED_OPTIONS;
  const optList = securities.filter(s => toString(s.security_type) !== toString(unissuedOptions));

  if (Array.isArray(optList)) {
    optList.forEach(opt => {
      if (opt.convertible_notes.length === 0) {
        tmpOptions.push({
          value: opt.id?.toString() ?? null,
          label: opt.name,
        });
      }
    });
  }

  return tmpOptions;
};
